import api from './axiosConfig';

import NormalizeOrders from "./NormalizeOrders";

export class FetchOrdersAction extends NormalizeOrders {

    controller = {};
    responsesData = {};
    response = null;

    constructor() {
        super();
        this.response = {};
    }
    
    /**
     * Leegt de cache van opgehaalde orders om verse data te forceren bij volgende aanvragen
     */
    clearCache() {
        this.responsesData = {};
        this.controller = {};
    }

    async getOrders(
        page = 1,
        pageSize = 50,
        sortField = 'updated_at',
        sortDirection = 'DESC',
        search = '',
        dataStart = '',
        dataEnd = '',
        status = '',
        customers = '',
        userAgent = '',
    ) {
        let requestKey = '/api/orders?';
        requestKey += `page=${page}&pageSize=${pageSize}`;
        requestKey += `&sortDirection=${sortDirection}&sortField=${sortField}`;
        requestKey += `&search=${search}&status=${status}`;
        requestKey += `&dataStart=${dataStart}&dataEnd=${dataEnd}`;
        requestKey += `&customers=${customers}&userAgent=${userAgent}`;

        // This caching mechanism is not working when returning to OrdersPage when in mean time the socket has pushed a new order
        if (this.responsesData[requestKey]) {
            return this.responsesData[requestKey];
        }

        if (this.controller[requestKey]) {
            this.controller[requestKey].abort();
        }
        this.controller[requestKey] = new AbortController();

        return this.#fetch(requestKey);
    }

    async #fetch(requestKey) {
        try {
            const response = await api.get(requestKey, {
                headers: { 'Content-Type': 'application/json' },
                signal: this.controller[requestKey].signal,
            });

            if (response.status === 401) {
                this._dispatchUnauthorized();
                return [];
            }

            if (response.status !== 200 || !response.data) {
                console.error('Invalid response:', response);
                return [];
            }

            const normalizedData = this._normalizeGetOrdersResponse(response.data);
            this.responsesData[requestKey] = normalizedData;

            // Dispatch event for UI updates
            this.#dispatchCustomEventWithDelay('ordersLoaded', response.data);

            return normalizedData;
        } catch (error) {
            return this.#handleGetOrdersError(error);
        }
    }

    #dispatchCustomEventWithDelay(eventName, detail, delay = 100) {
        //small timeout required to let data be incorporated in table
        setTimeout(() => {
            this.dispatchEvent(new CustomEvent(eventName, { detail }));
        }, delay);
    }

    #handleGetOrdersError(error) {
        if (error.name === 'AbortError' || error.name === 'CanceledError') {
            return [];
        }

        if (error?.response?.status === 401) {
            this._dispatchUnauthorized();
        } else {
            console.error('Error in response from server:', error.response?.data);
            this._dispatchCustomEvent('getOrdersFailed', error.response?.data || 'Error in database');
        }

        return [];
    }
}

export default new FetchOrdersAction();
